export default function EFCamera(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M2.52734 12.2903H10.3279" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21.6719 12.2903H29.4718" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.52734 23.552H11.0158" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.9141 23.552H29.4734" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.075 8.07915H28.1619C28.8866 8.07915 29.4747 8.66683 29.4747 9.39201V25.8702C29.4747 26.5953 28.8866 27.183 28.1619 27.183H3.8402C3.11551 27.183 2.52734 26.5953 2.52734 25.8702V9.39201C2.52734 8.66683 3.11551 8.07915 3.8402 8.07915H11.2557L12.7813 5.302H18.6104L20.075 8.07915Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M25.3533 6.3938H22.1797" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.26953 7.92212V6.42505H10.0122V7.92212" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.7082 17.617C23.7082 21.8729 20.2584 25.3226 16.0026 25.3226C11.7467 25.3226 8.29688 21.8729 8.29688 17.617C8.29688 13.3611 11.7467 9.91138 16.0026 9.91138C20.2584 9.91138 23.7082 13.3611 23.7082 17.617Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11.2734 17.2495C11.2734 14.8143 12.6326 13.1301 14.7379 13.1301" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
